export const FETCH_WAREHOUSES = {
  START: 'warehouses/FETCH_START',
  SUCCESS: 'warehouses/FETCH_SUCCESS',
  ERROR: 'warehouses/FETCH_ERROR',
};
// getWarehouses
export const SELECT_WAREHOUSE = 'warehouses/SELECT_WAREHOUSE';
export const DESELECT_WAREHOUSE = 'warehouses/DESELECT_WAREHOUSE';

// getHomeStores
export const FETCH_HOME_STORES = {
  START: 'warehouses/FETCH_HOME_STORES_START',
  SUCCESS: 'warehouses/FETCH_HOME_STORES_SUCCESS',
  ERROR: 'warehouses/FETCH_HOME_STORES_ERROR',
};
